import { render, staticRenderFns } from "./ConsultarFolio.vue?vue&type=template&id=9cb4275a&"
import script from "./ConsultarFolio.vue?vue&type=script&lang=ts&"
export * from "./ConsultarFolio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('9cb4275a', component.options)
    } else {
      api.reload('9cb4275a', component.options)
    }
    module.hot.accept("./ConsultarFolio.vue?vue&type=template&id=9cb4275a&", function () {
      api.rerender('9cb4275a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ConsultarFolio/ConsultarFolio.vue"
export default component.exports